import React, { useState } from "react";
import aboutImage from "../assests/services/a.jpg";
import aboutImage2 from "../assests/services/b3.jpeg";
import beforeImage from "../assests/services/f.png";
import afterImage from "../assests/services/e.png";
import heroBg from "../assests/services/d.png";
const whyChooseItems = [
  {
    question: "Are these laptops safe and reliable to buy?",
    answer:
      "Yes. Every laptop is carefully checked and tested to ensure stable performance before it reaches you.",
    image: aboutImage,
  },
  {
    question: "Will the laptop work smoothly for study or office work?",
    answer:
      "Absolutely. Our laptops are suitable for online classes, office tasks, browsing, and daily professional use without performance issues.",
    image: beforeImage,
  },
  {
    question: "How do I know I am getting value for my money?",
    answer:
      "We offer genuine branded laptops at fair prices, so you get strong performance without overspending.",
    image: afterImage,
  },
  {
    question: "What if I face any issue after buying?",
    answer:
      "We believe in long-term customer trust. If you face any genuine issue, our team is always ready to assist you.",
    image: heroBg,
  },
  {
    question: "Why do customers trust PC Care?",
    answer:
      "Because we focus on honest pricing, proper quality checks, and real customer satisfaction. Many buyers choose us again and recommend us to others.",
    image: aboutImage2,
  },
];

const WhyChoos = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const activeItem = whyChooseItems[activeIndex];

  return (
    <section className="relative overflow-hidden">
      <div className="pointer-events-none absolute -top-24 left-[-60px] h-72 w-72 rounded-full bg-[var(--pc-blue-2)]/60 blur-3xl"></div>
      <div className="pointer-events-none absolute -bottom-28 right-[-40px] h-80 w-80 rounded-full bg-[var(--pc-primary)]/15 blur-3xl"></div>

      <div className="mx-auto w-full max-w-7xl px-4">
        <div className="relative rounded-[30px]  md:p-8">
          <div className="lg:mb-8 mb-4 flex justify-center">
            <div className="text-center">
              <p className="text-xl font-black uppercase tracking-[0.12em] text-[var(--pc-primary)]">FAQ</p>
              <h2 className="lg:mt-2 text-2xl font-extrabold leading-tight text-[var(--pc-ink)] md:text-4xl">
                Smart Choice For Laptop Buyers
              </h2>
              <p className="mt-2 text-xs font-semibold text-[#4f5f8a] md:text-sm">
                Trusted Support | Genuine Guidance | Better Value
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-6 lg:grid-cols-[1fr_1.08fr]">
            <div className="space-y-3.5">
              {whyChooseItems.map((item, index) => {
                const isActive = activeIndex === index;
                return (
                  <button
                    key={item.question}
                    type="button"
                    onClick={() => setActiveIndex(index)}
                    className={`group w-full rounded-2xl border px-3.5 py-3.5 text-left transition-all duration-300 sm:px-4 sm:py-4 ${
                      isActive
                        ? "border-[var(--pc-primary)] bg-[linear-gradient(120deg,rgba(243,111,33,0.10),rgba(227,233,255,0.55))] shadow-[0_14px_28px_rgba(243,111,33,0.20)]"
                        : "border-[var(--pc-blue-2)] bg-white hover:-translate-y-0.5 hover:border-[var(--pc-primary)]/45 hover:shadow-[0_10px_20px_rgba(53,31,114,0.12)]"
                    }`}
                  >
                    <div className="flex items-start gap-3">
                      <span
                        className={`mt-0.5 inline-flex h-8 w-8 items-center justify-center rounded-full text-xs font-black ${
                          isActive
                            ? "bg-[var(--pc-primary)] text-white"
                            : "bg-[var(--pc-blue-1)] text-[var(--pc-ink)] group-hover:bg-[var(--pc-primary)] group-hover:text-white"
                        }`}
                      >
                        {index + 1}
                      </span>
                      <div className="flex-1">
                        <p className="text-sm font-extrabold text-[var(--pc-ink)] sm:text-base">{item.question}</p>
                        <p
                          className={`overflow-hidden text-xs leading-relaxed text-[#5d6b8f] transition-all duration-300 md:text-sm ${
                            isActive ? "mt-1.5 max-h-40 opacity-100" : "mt-0 max-h-0 opacity-0"
                          }`}
                        >
                          {item.answer}
                        </p>
                        {isActive && (
                          <div className="mt-3 overflow-hidden rounded-xl border border-[var(--pc-blue-2)] bg-[var(--pc-blue-1)] p-2 lg:hidden">
                            <div className="relative h-44 overflow-hidden rounded-lg">
                              <img src={item.image} alt={item.question} className="h-full w-full object-cover" />
                              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/75 to-transparent p-2.5">
                                <p className="text-xs font-semibold text-white">{item.question}</p>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                      <i
                        className={`fa-solid fa-arrow-right ml-auto mt-1 text-xs transition-transform ${
                          isActive ? "translate-x-1 text-[var(--pc-primary)]" : "text-[#7d8db6] group-hover:translate-x-1"
                        }`}
                        aria-hidden="true"
                      ></i>
                    </div>
                  </button>
                );
              })}
            </div>

            <div className="hidden space-y-3 lg:block">
              <div className="relative overflow-hidden rounded-2xl ">
                <div className="relative h-[320px] overflow-hidden rounded-xl md:h-[390px]">
                  <img
                    key={`${activeItem.image}-${activeIndex}`}
                    src={activeItem.image}
                    alt={activeItem.question}
                    className="h-full w-full object-cover transition-transform duration-500 hover:scale-[1.03]"
                  />
                  <div className="absolute left-3 top-3 inline-flex items-center gap-2 rounded-full bg-white/90 px-3 py-1.5 text-xs font-bold text-[var(--pc-ink)] backdrop-blur">
                    <i className="fa-solid fa-circle-check text-[var(--pc-primary)]" aria-hidden="true"></i>
                    Verified By PC Care
                  </div>
                  <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/75 to-transparent p-4">
                    <p className="text-sm font-bold text-white md:text-base">{activeItem.question}</p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChoos;
